export const GET_WALLET_TRANSACTIONS_LIST = null;